__turbopack_context__.v({
  "captchaWrap": "contact-form-module__2NVQPa__captchaWrap",
  "field": "contact-form-module__2NVQPa__field",
  "fieldGrid": "contact-form-module__2NVQPa__fieldGrid",
  "form": "contact-form-module__2NVQPa__form",
  "formError": "contact-form-module__2NVQPa__formError",
  "submitButton": "contact-form-module__2NVQPa__submitButton",
  "success": "contact-form-module__2NVQPa__success",
});
